import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';
import type {
  DeleteResult,
  DialplanDto,
  DialplanUpsert,
  OpensipsReloadResult,
  PreviewResult,
  WriteResult
} from './opensips.types';

const BASE = `${API_ENDPOINT.CORE}dialplan`;
const dry = { params: { dryRun: 'true' } };

/** Tabla `dialplan` de OpenSIPS. Mismo patrón dryRun → escribir → dp_reload que salientes/entrantes. */
export const DialplanService = {
  getDialplan: () => HTTP.get<DialplanDto[], DialplanDto[]>(BASE),
  getDialplanById: (id: string | number) => HTTP.get<DialplanDto, DialplanDto>(`${BASE}/${id}`),
  previewCreate: (data: DialplanUpsert) => HTTP.post<PreviewResult, PreviewResult>(BASE, data, dry),
  create: (data: DialplanUpsert) =>
    HTTP.post<WriteResult<DialplanDto>, WriteResult<DialplanDto>>(BASE, data),
  previewUpdate: (id: string | number, data: DialplanUpsert) =>
    HTTP.put<PreviewResult, PreviewResult>(`${BASE}/${id}`, data, dry),
  update: (id: string | number, data: DialplanUpsert) =>
    HTTP.put<WriteResult<DialplanDto>, WriteResult<DialplanDto>>(`${BASE}/${id}`, data),
  deleteDialplan: (id: string) => HTTP.delete<DeleteResult, DeleteResult>(`${BASE}/${id}`),
  /** dp_reload (supervisor/admin) */
  reload: () => HTTP.post<OpensipsReloadResult, OpensipsReloadResult>(`${BASE}/reload`, {})
};
